// Tax Mutations

export const setTaxList = (state, payload) => {
  state.taxList = payload
}

export const setTaxInfo = (state, payload) => {
  state.taxInfo = payload
}

export const setIncome = (state, payload) => {
  state.income = payload
}
